module.exports = __webpack_public_path__ + "static/media/spin-on.586e7fa0.png";